import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

// Pass `off` to draw a slash through the icon (muted / camera off). The gap
// under the slash takes `slashGapColor`, normally the button background.
function SvgComponent({
  off = false,
  slashGapColor = "#E5484D",
  ...props
}: SvgProps & { off?: boolean; slashGapColor?: string }) {
  return (
    <Svg width={42} height={27} viewBox="0 0 42 27" fill="none" {...props}>
      <Path
        d="M40.65 2.776a3 3 0 00-2.835-.255L28.5 6.496V4.5A4.605 4.605 0 0023.82 0H4.695A4.605 4.605 0 000 4.5v18A4.605 4.605 0 004.695 27H24a4.5 4.5 0 004.5-4.5v-1.995l9.315 3.975a2.998 2.998 0 002.835-.255 3.002 3.002 0 001.35-2.49v-16.5a3 3 0 00-1.35-2.46zM9.36 9H7.74a1.5 1.5 0 110-3h1.62a1.5 1.5 0 010 3z"
        fill="#F6F7F9"
      />
      {off && (
        <>
          <Path
            d="M4 1L38 26"
            stroke={slashGapColor}
            strokeWidth={9}
            strokeLinecap="round"
          />
          <Path
            d="M4 1L38 26"
            stroke="#F6F7F9"
            strokeWidth={4}
            strokeLinecap="round"
          />
        </>
      )}
    </Svg>
  );
}

export default SvgComponent;
